"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("reactstrap/lib/Row"));

var _utils = require("../lib/utils");

var Row = function Row(props) {
  var dataTestId = props.dataTestId,
      form = props.form,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props),
    noGutters: false,
    form: form
  }, children);
};

Row.propTypes = {
  form: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  dataTestId: _propTypes["default"].string
};
Row.defaultProps = {
  form: false,
  dataTestId: "orion-row"
};
Row.displayName = "OrionRow";
var _default = Row;
exports["default"] = _default;